// react
import { useContext } from 'react';

// context
import { ContextTransfers } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableTransfers } from '../../../../tables/cards/TableTransfers/TableTransfers';

export const Transfers = () => {
	// context
	const { transfers, isLoadingTransfers, paginationTransfers, refetchTransfers } =
		useContext(ContextTransfers);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableTransfers
						isLoading={isLoadingTransfers}
						pagination={paginationTransfers}
						refetchTransactions={refetchTransfers}
						transactions={transfers}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
